import styled from '@emotion/styled';

export const Wrapper = styled.section`
  min-height: ${({ theme }) => theme.vars.HeadersHeightD};
  position: relative;
  display: flex;
  align-items: flex-end;
  padding-top: ${({ theme }) => theme.spacings[6]};
  min-height: ${({ small }) => (small ? '33.25rem' : '45.8rem')};

  ${({ theme }) => theme.media.tablet} {
    padding-top: 0;
    align-items: flex-start;
    min-height: ${({ small }) => (small ? '28.25rem' : '42.8rem')};
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  max-width: ${({ small }) => (small ? '46.5rem' : '32rem')};
  width: ${({ small }) => (small ? '60%' : '45%')};

  ${({ theme }) => theme.media.tablet} {
    position: static;
    max-width: 27.5rem;
    margin: 0 auto;
    width: 100%;
  }
`;

export const Line = styled.div`
  margin-top: ${({ theme }) => theme.spacings[1]};
  height: ${({ theme }) => theme.spacings[1]};
  background: ${({ theme }) => theme.colors.pink};
  width: 6rem;

  ${({ theme }) => theme.media.tablet} {
    display: none;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 18rem;
  margin: ${({ theme }) => theme.spacings[3]} 0 0;

  ${({ theme }) => theme.media.tablet} {
    margin: ${({ theme }) => theme.spacings[3]} auto 0;
  }

  ${({ theme }) => theme.media.mobile} {
    margin: 0 auto;
  }
`;

export const DesktopWrapper = styled.div`
  ${({ theme }) => theme.media.tablet} {
    display: none;
  }
`;

export const TabletAndMobileWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.media.tablet} {
    display: block;
  }
`;
